export const BankAccountTypeFunding = [
  'checking',
  'savings'
];
